import { render, staticRenderFns } from "./ChangePasswordUser.vue?vue&type=template&id=bc943f40&"
import script from "./ChangePasswordUser.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordUser.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports